export default __webpack_public_path__ + "static/media/lima-costa_verde_day.982e1683.jpg";